import IBANSepa from "assets/config/IBANSepa.json";
export default function IBANSepaChekcer(iban){
    var code = iban.substring(0,2);
    if(IBANSepa["IBANSepaCodeList"].includes(code)) {
        return true;
    }
    else{
        return false;
    }
}